var map = {
	"./404.svg": 935,
	"./Categories.png": 936,
	"./Edit-menu.svg": 937,
	"./Egg.svg": 938,
	"./Emaier-Header.png": 939,
	"./Qr-4.png": 940,
	"./_duplicate.svg": 941,
	"./_overview.svg": 942,
	"./add-white.svg": 943,
	"./alert.svg": 944,
	"./all_category.svg": 945,
	"./archive.svg": 946,
	"./armchair.svg": 947,
	"./arrow-circle-right.svg": 948,
	"./arrow-left-circle.svg": 949,
	"./arrow-right-circle.svg": 950,
	"./arrow-right.svg": 350,
	"./asc-up-white.svg": 951,
	"./asc.png": 952,
	"./asc.svg": 953,
	"./back-arrow.svg": 954,
	"./barcode-icon.svg": 955,
	"./beverages.svg": 956,
	"./blue-edit-pen.svg": 957,
	"./blue-eye.svg": 958,
	"./box-office.svg": 959,
	"./broken-seat.jpg": 960,
	"./calendar_list.svg": 961,
	"./chevron-down.svg": 962,
	"./chevron-left.svg": 963,
	"./cinema-mamagement-sidebar.svg": 964,
	"./claendar.svg": 300,
	"./clock-1.svg": 965,
	"./clock.svg": 966,
	"./close-button.svg": 696,
	"./close-white.svg": 698,
	"./close-x.svg": 295,
	"./collapse-up.svg": 967,
	"./collapse.svg": 968,
	"./connection-lost.svg": 348,
	"./copy.svg": 969,
	"./copy_image_icon.png": 970,
	"./delete-red-light.svg": 971,
	"./delete-red.svg": 704,
	"./delete.svg": 681,
	"./deliver-icon.svg": 972,
	"./desc-down-white.svg": 973,
	"./desc.svg": 974,
	"./distributors-sidebar.svg": 975,
	"./download.svg": 976,
	"./dragndrop.svg": 977,
	"./dragndrop2.svg": 978,
	"./duplicate.svg": 979,
	"./duplicateScreen.svg": 980,
	"./e-wallet-icon-black.svg": 981,
	"./edit-pen-blue.svg": 982,
	"./edit-pen-white.svg": 983,
	"./edit-pen.svg": 984,
	"./edit.svg": 985,
	"./email.png": 986,
	"./empty-image.svg": 987,
	"./excel.svg": 988,
	"./external-link.svg": 989,
	"./eye.svg": 990,
	"./filter-icon.svg": 991,
	"./flag.svg": 992,
	"./fnb-app-order.svg": 993,
	"./fnb-beverages.svg": 994,
	"./fnb-brownie.svg": 995,
	"./fnb-combo.svg": 996,
	"./fnb-desert.svg": 997,
	"./fnb-eatables.svg": 998,
	"./fnb-make-your-combo.svg": 999,
	"./fnb-popcorn.svg": 1000,
	"./fnbtransactionIcon.svg": 1001,
	"./fullscreen-icon.svg": 705,
	"./funnel.svg": 1002,
	"./globe.svg": 1003,
	"./green-tick.svg": 1004,
	"./grid-view.svg": 1005,
	"./hide-password.svg": 351,
	"./home-icon.svg": 1006,
	"./home.svg": 1007,
	"./icon-black-play.svg": 1008,
	"./icon-dot.svg": 1009,
	"./icon-fnb.svg": 1010,
	"./icon-marketing.svg": 1011,
	"./icon-no-seat.png": 1012,
	"./icon-no-seat.svg": 1013,
	"./icon-option.svg": 1014,
	"./icon-poin-of-sale.svg": 1015,
	"./icon-recliner.svg": 1016,
	"./icon-report.svg": 1017,
	"./icon-sofa-dark-1.svg": 1018,
	"./icon-sofa-dark.png": 1019,
	"./icon-sofa-dark.svg": 1020,
	"./icon-sofa.svg": 1021,
	"./importfile.svg": 1022,
	"./info.svg": 699,
	"./info2.svg": 1023,
	"./keyboard-icon.svg": 1024,
	"./kitchen_display.svg": 1025,
	"./language-icon.svg": 296,
	"./left-caret.svg": 1026,
	"./link.svg": 1027,
	"./list-view.svg": 1028,
	"./loading.svg": 352,
	"./lock.svg": 1029,
	"./login-password.png": 353,
	"./login-user.png": 354,
	"./logout.svg": 700,
	"./masters-sidebar.svg": 1030,
	"./merchandise.svg": 1031,
	"./minus.svg": 1032,
	"./movie-pass-svg.svg": 687,
	"./movie-rolling.svg": 1033,
	"./mulitSchedule.svg": 1034,
	"./multicurrency.svg": 1035,
	"./multifnb.svg": 1036,
	"./nav-plus.svg": 1037,
	"./new_filter_icon.svg": 1038,
	"./no-image.svg": 1039,
	"./no-schedule.svg": 132,
	"./non-veg-mark.png": 1040,
	"./non-veg-mark.svg": 1041,
	"./notification.svg": 1042,
	"./open-link-blue.svg": 1043,
	"./openPlanned.svg": 1044,
	"./overview.svg": 1045,
	"./overview2.svg": 1046,
	"./pdf-icon.svg": 1047,
	"./pdf.svg": 1048,
	"./pickup-ticket-icon.svg": 1049,
	"./pickupfnb.svg": 1050,
	"./play.svg": 1051,
	"./plus.svg": 1052,
	"./pointofsale-1.svg": 1053,
	"./pointofsale-2.svg": 1054,
	"./pointofsale.png": 1055,
	"./portfolio.svg": 1056,
	"./pos-fnb-no-itmes.svg": 693,
	"./pos-refresh.svg": 1057,
	"./primary/chevron-down.svg": 1058,
	"./primary/download.svg": 1059,
	"./primary/edit.svg": 1060,
	"./primary/filter.svg": 1061,
	"./primary/printer.svg": 1062,
	"./print-icon.svg": 1063,
	"./print.svg": 1064,
	"./question.svg": 1065,
	"./question1.svg": 1066,
	"./question2.svg": 706,
	"./question3.svg": 1067,
	"./recliner-1.svg": 1068,
	"./recliner.png": 1069,
	"./refund-icon.svg": 1070,
	"./reload-icon-pos.svg": 1071,
	"./reload-icon.svg": 1072,
	"./restore.svg": 1073,
	"./right-caret.svg": 1074,
	"./role-management-sidebar.svg": 1075,
	"./save.svg": 1076,
	"./schedule-icon.svg": 1077,
	"./school-calendar.svg": 1078,
	"./search-global-white.svg": 1079,
	"./search-global.svg": 1080,
	"./search.svg": 707,
	"./searchIcon.svg": 1081,
	"./seat-icon-2.svg": 1082,
	"./seat-icon.svg": 1083,
	"./seat-icons/3-wheelChair.png": 1084,
	"./seat-icons/block_seat_new.png": 1085,
	"./seat-icons/broken-seat-1.svg": 1086,
	"./seat-icons/broken-seat-2.svg": 1087,
	"./select-food.png": 708,
	"./settings.svg": 1088,
	"./show-password.svg": 355,
	"./slider-triangle.svg": 1089,
	"./snack.svg": 701,
	"./sort.svg": 1090,
	"./star-empty.svg": 1091,
	"./star-fill.svg": 1092,
	"./success-tick.svg": 1093,
	"./suitcase.svg": 1094,
	"./swap.svg": 1095,
	"./tick-green-item.svg": 709,
	"./tick-green.svg": 1096,
	"./ticket-icon.svg": 1097,
	"./trash.svg": 1098,
	"./unpaid-reservation.svg": 683,
	"./updown-white.svg": 1099,
	"./updown.svg": 1100,
	"./user-attribute.svg": 1101,
	"./user-attributes.svg": 1102,
	"./user-female.svg": 1103,
	"./user-male-white.svg": 1104,
	"./user-male.svg": 1105,
	"./user-profile.svg": 1106,
	"./userProfile.png": 1107,
	"./veg-food-mark-white.png": 1108,
	"./veg-foog-mark-trans.png": 1109,
	"./view.png": 1110,
	"./view.svg": 1111
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 934;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 934
// module chunks = 33